import { FilterModel } from '../components/filter-checkbox-tree/filter-checkbox-tree.component';
import { ArrayHelper } from '../../../models/helpers/array-helper';
import * as i0 from "@angular/core";
export class FilterService {
    constructor() {
    }
    static makeFilterModels(values, titleSelector, existingFilters, undefinedValueTitle) {
        let titles = this.mapValues(values, titleSelector);
        let filters = ArrayHelper.getDistinct(titles)
            .filter((value) => value != null && !!value.trim())
            .sort((a, b) => a.localeCompare(b))
            .map(title => new FilterModel(title, value => {
            let selectedValue = titleSelector(value);
            if (typeof selectedValue === 'string')
                return title == selectedValue;
            if (!selectedValue)
                return false;
            return selectedValue.includes(title);
        }, this.shouldSelect(title, existingFilters)));
        if (undefinedValueTitle && titles.some(value => !value)) {
            filters.unshift(new FilterModel(undefinedValueTitle, v => {
                let selectedValue = titleSelector(v);
                if (!selectedValue)
                    return true;
                if (typeof selectedValue === 'string')
                    return false;
                return selectedValue.length == 0;
            }, this.shouldSelect(undefinedValueTitle, existingFilters)));
        }
        return filters;
    }
    static mapValues(array, selector) {
        let result = [];
        for (let value of array) {
            let selectedValue = selector(value);
            if (typeof selectedValue === 'string') {
                result.push(selectedValue);
                continue;
            }
            if (!selectedValue) {
                result.push(null);
                continue;
            }
            if (selectedValue.length == 0) {
                result.push(null);
                continue;
            }
            for (let r of selectedValue) {
                result.push(r);
            }
        }
        return result;
    }
    static shouldSelect(title, existingFilters) {
        if (existingFilters == null || existingFilters.length == 0)
            return true;
        let existingFilter = existingFilters.find(filter => filter.name == title);
        if (existingFilter == null)
            return true;
        return existingFilter.selected;
    }
    static combineFiltersWithOr(filters) {
        return value => {
            for (let filter of filters) {
                if (filter.matches(value))
                    return true;
            }
            return false;
        };
    }
}
FilterService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function FilterService_Factory() { return new FilterService(); }, token: FilterService, providedIn: "root" });
